
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, Tooltip, Legend, CategoryScale, BarElement, LinearScale, Title } from 'chart.js';
import { colors } from '../../utilities/formats';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const HorizontalStackedBar = ({ data }) => {

    let total = 0;
    for (const key in data) {
        total += data[key];
    }

    const opts = {
        animation: false,
        hover: { mode: null },
        barThickness: 35,
        indexAxis: 'y',
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                display: false,
                max: total
            },
            y: {
                stacked: true,
                display: false
            }
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const data = context.dataset.data;
                        const currentValue = data[context.dataIndex];
                        return `${context.dataset.label} ${(currentValue * 100).toFixed(1)
                            }%`;
                    }
                }
            },
            legend: {
                onClick: (e) => { },  // Disable legend click interactivity
                onHover: (e) => { },   // Disable legend hover interactivity
                display: true,
                position: 'bottom',
                labels: {
                    font: {
                        family: '"Open Sans", sans-serif',
                        fontSize: 14,
                    },
                    color: '#000',
                    boxWidth: 10,
                    boxHeight: 10,
                    usePointStyle: true
                },
            }
        },
    };

    const formattedData = {
        labels: ["Overall"],

        datasets: [{
            label: "Graduated",
            data: [data.graduated],
            backgroundColor: colors.blue,
            hoverBackgroundColor: "#194F85"
        }, {
            label: "Transferred",
            data: [data.transferred],
            backgroundColor: colors.green,
            hoverBackgroundColor: "#142E4E"
        }, {
            label: "Withdrew",
            data: [data.withdrew],
            backgroundColor: colors.yellow,
            hoverBackgroundColor: "#E19D41"
        }, {
            label: "Still Enrolled",
            data: [data.still_enrolled],
            backgroundColor: colors.lightblue,
            hoverBackgroundColor: "#A4C6E6"
        }
        ]
    };

    return (
        <div style={{ height: '100px' }}>
            <Bar
                data={formattedData}
                options={opts}
                plugins={[CategoryScale]}
            />
        </div>
    )
};

export default HorizontalStackedBar;